<div class="m-6">
  <h1 data-cy="test-patients-page-title">Test Patients</h1>

  <div *ngIf="!isApiMocked" class="flex flex-column mt-4 mb-4 justify-content-end">
    <h2 data-cy="load-test-patient-form-title">Load Test Patient</h2>
    <p-card styleClass="mb-5">
      <app-message
        *ngIf="
          !!loadTestPatientErrorMessage &&
          (testPatientId$ | async) !== null &&
          (testPatientId$ | async) === patientForm.get('patientId')!.value
        "
        severity="error"
        data-cy="load-test-patient-from-form-error"
      >
        {{ loadTestPatientErrorMessage }}
      </app-message>
      <form [formGroup]="patientForm" (ngSubmit)="onSubmitPatientForm()" data-cy="find-test-patient-by-id-form">
        <div class="formgroup justify-content-end align-items-end">
          <app-form-field
            [limitWidth]="true"
            [control]="asFormControl(patientForm.get('patientId'))"
            name="patientid"
            label="Test Patient ID"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <div class="flex flex-wrap">
            <app-form-field
              [noMargin]="true"
              [control]="asFormControl(patientForm.get('paymentMethodOption'))"
              name="paymentMethodOption"
              label="Payment Method State"
              [boldLabel]="true"
              type="radio"
              [options]="paymentMethodOptions"
              [noMargin]="true"
              class="mr-4 mb-3"
            ></app-form-field>
            <app-form-field
              [noMargin]="true"
              [control]="asFormControl(patientForm.get('notificationOption'))"
              name="notificationOption"
              label="Notification State"
              [boldLabel]="true"
              type="radio"
              [options]="notificationOptions"
              [noMargin]="true"
              class="mr-4 mb-3"
            ></app-form-field>
            <app-form-field
              [noMargin]="true"
              [control]="asFormControl(patientForm.get('copayExclusionOption'))"
              name="copayExclusionOption"
              label="Copay Exclusion State"
              [boldLabel]="true"
              type="radio"
              [options]="copayExclusionOptions"
              [noMargin]="true"
              class="mr-4 mb-3"
            ></app-form-field>
            <app-form-field
              [noMargin]="true"
              [control]="asFormControl(patientForm.get('deductibleOverrideOption'))"
              name="deductibleOverrideOption"
              label="Deductible Overrides State"
              [boldLabel]="true"
              type="radio"
              [options]="deductibleOverrideOptions"
              [noMargin]="true"
              class="mr-4 mb-3"
            ></app-form-field>
          </div>
          <div class="flex align-items-center">
            <button
              pButton
              class="button p-button-lg p-button-rounded"
              type="submit"
              data-cy="find-test-patient-by-id-form-submit-button"
              [disabled]="
                (testPatientLoading$ | async) &&
                (testPatientId$ | async) !== null &&
                (testPatientId$ | async) === patientForm.get('patientId')!.value
              "
            >
              Go
            </button>
            <app-spinner
              *ngIf="
                (testPatientLoading$ | async) &&
                (testPatientId$ | async) !== null &&
                (testPatientId$ | async) === patientForm.get('patientId')!.value
              "
              class="test-patient-loading-spinner ml-4"
              [small]="true"
              [noMargin]="true"
              data-cy="load-test-patient-form-spinner"
            ></app-spinner>
          </div>
        </div>
      </form>
    </p-card>

    <h2 data-cy="find-test-patient-form-title">Find Test Patients</h2>
    <form [formGroup]="findTestPatientsForm" (ngSubmit)="onSubmitFindPatient()" data-cy="find-test-patient-form">
      <p-card>
        <h3 data-cy="past-orders-section-title">Past Orders</h3>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('minNumOfPastOrders'))"
            name="minNumOfPastOrders"
            label="Min Number of Past Orders"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            [control]="asFormControl(findTestPatientsForm.get('maxNumOfPastOrders'))"
            name="maxNumOfPastOrders"
            label="Max Number of Past Orders"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
        </div>
        <hr />
        <h3 data-cy="reorders-section-title">Reorders</h3>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('hasReorders'))"
            name="hasReorders"
            label="Patient Has Reorders"
            type="checkbox-binary"
            inputType="checkbox"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            *ngIf="findTestPatientsForm.get('hasReorders')?.value === true"
            [control]="asFormControl(findTestPatientsForm.get('minNumOfReorders'))"
            name="minNumOfReorders"
            label="Min Number of Reorders"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            *ngIf="findTestPatientsForm.get('hasReorders')?.value === true"
            [control]="asFormControl(findTestPatientsForm.get('maxNumOfReorders'))"
            name="maxNumOfReorders"
            label="Max Number of Reorders"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('targetShipDateDaysBack'))"
            name="targetShipDateDaysBack"
            label="Min Target Ship Date (Days in the Past)"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            [control]="asFormControl(findTestPatientsForm.get('targetShipDateDaysForward'))"
            name="targetShipDateDaysForward"
            label="Max Target Ship Date (Days in the Future)"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
        </div>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            [control]="asFormControl(findTestPatientsForm.get('authorizeViaExistingShipments'))"
            name="authorizeViaExistingShipments"
            type="radio"
            label="Shipment Types"
            [boldLabel]="true"
            [options]="[
              { label: 'Existing Shipment Types', value: true },
              { label: 'Reorder Card Shipment Types', value: false }
            ]"
            [horizontalLayout]="true"
          ></app-form-field>
        </div>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            *ngIf="findTestPatientsForm.get('authorizeViaExistingShipments')?.value"
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('existingShipmentTypeIds'))"
            name="existingShipmentTypeIds"
            label="Existing Shipment Types"
            [boldLabel]="true"
            type="multiselect"
            [options]="existingShipmentTypeOptions"
          ></app-form-field>
        </div>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            *ngIf="!findTestPatientsForm.get('authorizeViaExistingShipments')?.value"
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('shipmentTypeIds'))"
            name="shipmentTypeIds"
            label="Reorder Card Shipment Types"
            [boldLabel]="true"
            type="multiselect"
            [options]="shipmentTypeOptions"
          ></app-form-field>
        </div>

        <hr />
        <h3 data-cy="reorder-items-section-title">Reorder Items</h3>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('minNumOfReorderItems'))"
            name="minNumOfReorderItems"
            label="Min Number of Reorder Items"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('maxNumOfReorderItems'))"
            name="maxNumOfReorderItems"
            label="Max Number of Reorder Items"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('hasMismatchingTargetShipDates'))"
            name="hasMismatchingTargetShipDates"
            label="Reorder Has Mismatched Ship Dates"
            [boldLabel]="true"
            type="selectbutton"
            [options]="mismatchedShipDatesOptions"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('hasNoChargeItems'))"
            name="hasNoChargeItems"
            label="Reorder Has No Charge Items"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('hasMissingDocumentation'))"
            name="hasMissingDocumentation"
            label="Reorder Has Missing Documentation"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('hasSetsOrReservoirs'))"
            name="hasSetsOrReservoirs"
            label="Reorder Has Sets or Reservoirs"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('hasSensors'))"
            name="hasSensors"
            label="Reorder Has Sensors"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
          <app-form-field
            [control]="asFormControl(findTestPatientsForm.get('hasTestingSupplies'))"
            name="hasTestingSupplies"
            label="Reorder Has Testing Supplies"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
        </div>
        <hr />
        <h3 data-cy="insurance-section-title">Insurance</h3>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('minNumOfInsurances'))"
            name="minNumOfInsurances"
            label="Min Number of Insurances"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('maxNumOfInsurances'))"
            name="maxNumOfInsurances"
            label="Max Number of Insurances"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
        </div>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            [control]="asFormControl(findTestPatientsForm.get('insuranceTypeIds'))"
            name="insuranceTypeIds"
            label="Insurance Types"
            [boldLabel]="true"
            type="multiselect"
            [options]="insuranceTypeOptions"
          ></app-form-field>
        </div>
        <hr />
        <h3 data-cy="product-section-title">Product</h3>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('hasDaysOnHandRequired'))"
            name="hasDaysOnHandRequired"
            label="Patient Has Days On Hand Items"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('hasTestingFrequencyRequired'))"
            name="hasTestingFrequencyRequired"
            label="Patient Has Testing Frequency Items"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
          <app-form-field
            [control]="asFormControl(findTestPatientsForm.get('hasPumpSiteChangeFrequencyRequired'))"
            name="hasPumpSiteChangeFrequencyRequired"
            label="Patient Has Pump Site Change Frequency Items"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
        </div>
        <hr />
        <h3 data-cy="providers-section-title">Providers</h3>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('minNumOfProviders'))"
            name="minNumOfProviders"
            label="Min Number of Providers"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('maxNumOfProviders'))"
            name="maxNumOfProviders"
            label="Max Number of Providers"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            [control]="asFormControl(findTestPatientsForm.get('hasLastProviderVisit'))"
            name="hasLastProviderVisit"
            label="Patient Requires Last Provider Visit"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
        </div>
        <hr />
        <h3 data-cy="addresses-section-title">Addresses</h3>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('minNumOfAddresses'))"
            name="minNumOfAddresses"
            label="Min Number of Addresses"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            [control]="asFormControl(findTestPatientsForm.get('maxNumOfAddresses'))"
            name="maxNumOfAddresses"
            label="Max Number of Addresses"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
        </div>
        <hr />
        <h3 data-cy="billing-section-title">Billing</h3>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('minOutstandingBalance'))"
            name="minOutstandingBalance"
            label="Min Outstanding Balance"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('maxOutstandingBalance'))"
            name="maxOutstandingBalance"
            label="Max Outstanding Balance"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('hasPaymentPlan'))"
            name="hasPaymentPlan"
            label="Patient Has Payment Plan"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
          <app-form-field
            [control]="asFormControl(findTestPatientsForm.get('hasRentalSchedule'))"
            name="hasRentalSchedule"
            label="Patient Has Rental Schedule"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
        </div>
        <hr />
        <h3 data-cy="other-section-title">Other</h3>
        <div class="flex flex-wrap align-items-center">
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('isPortalUser'))"
            name="isPortalUser"
            label="Is Portal User"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
          <app-form-field
            class="mr-5"
            [control]="asFormControl(findTestPatientsForm.get('isNewLeafPatient'))"
            name="isNewLeafPatient"
            label="Is NewLeaf Patient"
            [boldLabel]="true"
            type="selectbutton"
            [options]="selectButtonOptions"
          ></app-form-field>
          <app-form-field
            [control]="asFormControl(findTestPatientsForm.get('limit'))"
            name="limit"
            label="Max Number of Results"
            [boldLabel]="true"
            type="input"
            inputType="number"
            inputMode="numeric"
          ></app-form-field>
        </div>
        <div class="flex w-full justify-content-end">
          <button
            pButton
            class="button p-button-lg p-button-rounded"
            type="submit"
            data-cy="find-test-patient-form-submit-button"
          >
            Submit
          </button>
        </div>
      </p-card>
    </form>
  </div>
  <app-spinner *ngIf="isLoading$ | async" data-cy="test-patient-data-spinner"></app-spinner>
  <div *ngIf="(isLoading$ | async) !== true">
    <div *ngIf="error$ | async" data-cy="test-patient-data-error-message">
      <p>Error: {{ error$ | async }}</p>
    </div>
    <h2 *ngIf="!!(testPatients$ | async)" data-cy="test-patient-data-title">
      Found {{ (testPatients$ | async)?.length }} Test Patient{{ (testPatients$ | async)?.length !== 1 ? 's' : '' }}
    </h2>
    <div
      class="flex flex-column rounded-container border-grey-200 border-1 mb-4 py-6 px-6 bg-white"
      *ngFor="let patient of testPatients$ | async"
      data-cy="test-patient-data-container"
    >
      <app-message
        *ngIf="
          !!loadTestPatientErrorMessage && (testPatientId$ | async) !== null && (testPatientId$ | async) === patient.id
        "
        severity="error"
        data-cy="load-test-patient-from-results-error"
      >
        {{ loadTestPatientErrorMessage }}
      </app-message>
      <div class="flex flex-wrap justify-content-between w-full">
        <div class="col-12 lg:col-3" data-cy="test-patient-bio-data-container">
          <div class="flex">
            <p-avatar
              *ngIf="
                !(
                  (testPatientLoading$ | async) &&
                  (testPatientId$ | async) !== null &&
                  (testPatientId$ | async) === patient.id
                )
              "
              icon="pi pi-user"
              shape="circle"
              size="large"
              styleClass="mr-3 align-self-center"
              [style]="{ 'background-color': 'grey' }"
              data-cy="test-patient-icon"
            ></p-avatar>
            <app-spinner
              *ngIf="
                (testPatientLoading$ | async) &&
                (testPatientId$ | async) !== null &&
                (testPatientId$ | async) === patient.id
              "
              class="test-patient-loading-spinner mr-3"
              alignSpinner="left"
              [noMargin]="true"
              alignSpinner="left"
              data-cy="load-test-patient-avatar-spinner"
            ></app-spinner>
            <div class="flex flex-column justify-content-between">
              <div>
                <a [routerLink]="" (click)="onClickPatientLink(patient.id)" data-cy="test-patient-id">{{
                  patient.id
                }}</a>
              </div>
              <h3 class="m-0 inline-block line-height-1" data-cy="test-patient-name">
                {{ patient.firstName }} {{ patient.lastName }}
              </h3>
            </div>
          </div>
        </div>
        <div class="col-12 lg:col-9 flex flex-wrap" data-cy="test-patient-other-data-container">
          <div class="col-12 lg:col-6 flex flex-column p-0">
            <span class="p-1" data-cy="test-patient-primary-insurance-type-container">
              Primary Insurance Type:
              <span class="font-medium" data-cy="test-patient-primary-insurance-type-value">{{
                patient.insuranceTypeName
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-primary-insurance-group-container">
              Primary Insurance Report Group:
              <span class="font-medium" data-cy="test-patient-primary-insurance-group-value">{{
                patient.primaryReportGroup
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-balance-container">
              Current Balance:
              <span class="font-medium" data-cy="test-patient-balance-value">{{
                patient.balance | formatCurrency
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-payment-plan-container">
              Has Payment Plan:
              <span class="font-medium" data-cy="test-patient-payment-plan-value">{{
                patient.hasPaymentPlan | formatBoolean
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-rental-schedule-container">
              Has Rental Schedule:
              <span class="font-medium" data-cy="test-patient-rental-schedule-value">{{
                patient.hasRentalSchedule | formatBoolean
              }}</span>
            </span>
          </div>
          <div class="col-12 lg:col-6 flex flex-column p-0">
            <span class="p-1" data-cy="test-patient-num-insurances-container">
              Number of Insurances:
              <span class="font-medium" data-cy="test-patient-num-insurances-value">{{ patient.numOfInsurances }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-num-providers-container">
              Number of Providers:
              <span class="font-medium" data-cy="test-patient-num-providers-value">{{ patient.numOfProviders }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-num-addresses-container">
              Number of Addresses:
              <span class="font-medium" data-cy="test-patient-num-addresses-value">{{ patient.numOfAddresses }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-num-past-orders-container">
              Number of Past Orders:
              <span class="font-medium" data-cy="test-patient-num-past-orders-value">{{
                patient.numOfPastOrders
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <h3 *ngIf="patient.reorderCards.length > 0" class="mb-0 mt-4" data-cy="test-patient-reorders-title">Reorders</h3>
      <div
        *ngFor="let reorder of patient.reorderCards"
        class="flex flex-wrap justify-content-between rounded-container border-grey-200 border-1 py-3 px-3 mt-3"
        data-cy="test-patient-reorders-container"
      >
        <a
          [routerLink]=""
          (click)="onClickReorderLink(patient.id, reorder.orderId)"
          data-cy="test-patient-reorder-id"
          >{{ reorder.orderId }}</a
        >
        <div class="col-12 lg:col-10 flex flex-wrap" data-cy="test-patient-reorders-data-container">
          <div class="col-12 lg:col-7 flex flex-column p-0">
            <span class="p-1" data-cy="test-patient-num-reorder-items-container">
              Number of Items:
              <span class="font-medium" data-cy="test-patient-num-reorder-items-value">{{
                reorder.numOfReorderItems
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-no-charge-items-container">
              Number of No Charge Items:
              <span class="font-medium" data-cy="test-patient-no-charge-items-value">{{
                reorder.numOfNoChargeItems
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-set-reservoir-items-container">
              Number of Set/Reservoir Items:
              <span class="font-medium" data-cy="test-patient-set-reservoir-items-value">{{
                reorder.numOfSetOrReservoirItems
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-sensor-items-container">
              Number of Sensor Items:
              <span class="font-medium" data-cy="test-patient-sensor-items-value">{{ reorder.numOfSensorItems }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-testing-supply-items-container">
              Number of Testing Supply Items:
              <span class="font-medium" data-cy="test-patient-testing-supply-items-value">{{
                reorder.numOfTestingSupplyItems
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-days-on-hand-items-container">
              Number of Days On Hand Items:
              <span class="font-medium" data-cy="test-patient-days-on-hand-items-value">{{
                reorder.numOfDaysOnHandRequiredItems
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-testing-frequency-required-items-container">
              Number of Testing Frequency Items:
              <span class="font-medium" data-cy="test-patient-testing-frequency-required-items-value">{{
                reorder.numOfTestingFrequencyRequiredItems
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-pump-site-change-frequency-required-items-container">
              Number of Pump Site Change Frequency Items:
              <span class="font-medium" data-cy="test-patient-pump-site-change-frequency-required-items-value">{{
                reorder.numOfPumpSiteChangeFrequencyRequiredItems
              }}</span>
            </span>
          </div>
          <div class="col-12 lg:col-5 flex flex-column p-0">
            <span class="p-1" data-cy="test-patient-shipment-type-container">
              Shipment Type:
              <span class="font-medium" data-cy="test-patient-shipment-type-value">{{ reorder.shipmentTypeDesc }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-date-of-service-container">
              Date of Service:
              <span class="font-medium" data-cy="test-patient-date-of-service-value">{{
                reorder.dateOfService | formatDate
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-target-ship-date-container">
              Target Ship Date:
              <span class="font-medium" data-cy="test-patient-target-ship-date-value">{{
                reorder.targetShipDate | formatDate
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-has-missing-docs-container">
              Has Missing Documentation:
              <span class="font-medium" data-cy="test-patient-has-missing-docs-value">{{
                reorder.hasMissingDocumentation | formatBoolean
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-last-provider-visit-container">
              Last Provider Visit Required:
              <span class="font-medium" data-cy="test-patient-last-provider-visit-value">{{
                reorder.lastProviderVisitRequired | formatBoolean
              }}</span>
            </span>
            <span class="p-1" data-cy="test-patient-has-mismatching-ship-dates-container">
              Has Mismatched Ship Dates:
              <span class="font-medium" data-cy="test-patient-has-mismatching-ship-dates-value">{{
                reorder.hasMismatchingTargetShipDates | formatBoolean
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <h3 class="mb-0 my-4" data-cy="test-patient-actions-title">Actions</h3>
      <div class="rounded-container border-grey-200 border-1">
        <div class="flex flex-wrap p-3 mb-5">
          <app-form-field
            [noMargin]="true"
            [control]="asFormControl(patientResultsFormLookup[patient.id].get('paymentMethodOption'))"
            name="paymentMethodOption"
            label="Payment Method State"
            [boldLabel]="true"
            type="radio"
            [options]="paymentMethodOptions"
            class="mr-4 mb-3"
          ></app-form-field>
          <app-form-field
            [noMargin]="true"
            [control]="asFormControl(patientResultsFormLookup[patient.id].get('notificationOption'))"
            name="notificationOption"
            label="Notification State"
            [boldLabel]="true"
            type="radio"
            [options]="notificationOptions"
            class="mr-4 mb-3"
          ></app-form-field>
          <app-form-field
            [noMargin]="true"
            [control]="asFormControl(patientResultsFormLookup[patient.id].get('copayExclusionOption'))"
            name="copayExclusionOption"
            label="Copay Exclusion State"
            [boldLabel]="true"
            type="radio"
            [options]="copayExclusionOptions"
            class="mr-4 mb-3"
          ></app-form-field>
          <app-form-field
            [noMargin]="true"
            [control]="asFormControl(patientResultsFormLookup[patient.id].get('deductibleOverrideOption'))"
            name="deductibleOverrideOption"
            label="Deductible Overrides State"
            [boldLabel]="true"
            type="radio"
            [options]="deductibleOverrideOptions"
            class="mr-4 mb-3"
          ></app-form-field>
        </div>

        <div class="flex flex-wrap px-3 mb-3" data-cy="test-patient-actions-container">
          <button
            pButton
            class="button p-button-sm p-button-rounded"
            type="button"
            (click)="onUpdatePatient($event, patient.id, UpdatePatientAction.AcceptTermsAndConditions)"
            data-cy="update-patient-accept-tnc-button"
          >
            Accept T&C
          </button>
          <button
            pButton
            class="button p-button-sm p-button-rounded ml-4"
            type="button"
            (click)="onUpdatePatient($event, patient.id, UpdatePatientAction.RevokeTermsAndConditions)"
            data-cy="update-patient-revoke-tnc-button"
          >
            Revoke T&C
          </button>
          <button
            pButton
            class="button p-button-sm p-button-rounded ml-4"
            type="button"
            (click)="onUpdatePatient($event, patient.id, UpdatePatientAction.ConsentToMarketing)"
            data-cy="update-patient-accept-marketing-button"
          >
            Consent to Marketing
          </button>
          <button
            pButton
            class="button p-button-sm p-button-rounded ml-4"
            type="button"
            (click)="onUpdatePatient($event, patient.id, UpdatePatientAction.RevokeMarketingConsent)"
            data-cy="update-patient-revoke-marketing-button"
          >
            Revoke Marketing Consent
          </button>
        </div>
        <div class="col-12 lg:col-5 flex flex-column p-3">
          <span class="p-1" data-cy="test-patient-tnc-container">
            T&C:
            <span class="font-medium" data-cy="test-patient-tnc-value">{{ getTestPatientTnC(patient.id) }}</span>
          </span>
          <span class="p-1" data-cy="test-patient-tnc-container">
            Marketing Consent:
            <span class="font-medium" data-cy="test-patient-tnc-value">{{
              getTestPatientMarketingConsent(patient.id)
            }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
